(function(){
  // ── Announcement bar → header offset ─────────────────────────────────────
  var annBar = document.getElementById('cvAnnBar');
  var annClose = document.getElementById('cvAnnClose');

  function updateHeaderOffset(){
    var h = annBar && !annBar.classList.contains('cv-ann--hidden')
      ? annBar.offsetHeight
      : 0;
    document.documentElement.style.setProperty('--cv-ann-h', h + 'px');
  }

  // Nastaví offset hned při načtení
  updateHeaderOffset();

  // Když se lišta zavře, okamžitě posun header nahoru
  if(annClose){
    annClose.addEventListener('click', function(){
      // Krátká prodleva = čeká na fade-out animaci lišty (260ms)
      setTimeout(updateHeaderOffset, 280);
    });
  }

  // Záloha: pokud lišta zmizí jinak (JS sessionStorage reload)
  window.addEventListener('load', updateHeaderOffset);

  // ── Header scroll ─────────────────────────────────────────────────────────
  var header = document.getElementById('cv-header');
  if(header){
    window.addEventListener('scroll', function(){
      if(window.scrollY > 50) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    });
  }

  // ── Mobile nav ────────────────────────────────────────────────────────────
  var hamburger = document.getElementById('cv-hamburger');
  var mobileNav = document.getElementById('cv-mobile-nav');
  var overlay   = document.getElementById('cv-nav-overlay');
  var closeBtn  = document.getElementById('cv-mobile-close');

  function openNav(){
    mobileNav.classList.add('is-open');
    overlay.classList.add('is-visible');
    hamburger.classList.add('is-open');
    hamburger.setAttribute('aria-expanded','true');
    mobileNav.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
  }
  function closeNav(){
    mobileNav.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    hamburger.classList.remove('is-open');
    hamburger.setAttribute('aria-expanded','false');
    mobileNav.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
  }

  if(hamburger) hamburger.addEventListener('click', function(){
    mobileNav.classList.contains('is-open') ? closeNav() : openNav();
  });
  if(closeBtn)  closeBtn.addEventListener('click', closeNav);
  if(overlay)   overlay.addEventListener('click', closeNav);

  if(mobileNav) mobileNav.querySelectorAll('a').forEach(function(a){
    a.addEventListener('click', closeNav);
  });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') closeNav();
  });
})();
